module.exports = __webpack_public_path__ + "img/checkmark.0b7d5230.svg";